<h3 *ngIf="title && !noTitle" class="title title--settings">
    <div class="title__info">
        {{ title }}
        <metric-help-icon [measure]="normalizedMetrics[normalizedMetrics.length - 1].metric.id"></metric-help-icon>
    </div>

    <ng-container *ngIf="!loader.dataLoader.isLoading">
        <i
            class="title__icn icn"
            [ngClass]="tooltipService.multipleTooltipInc$ | async"
            (click)="toggleAppearanceTooltip()"
            [nz-tooltip]="'Change tooltip display format'"
        ></i>
    </ng-container>
</h3>

<blur-chart-wrapper class="container" [loading]="loading$ | async" [error]="loader.dataLoader.errorMessage" (errorRetryCallback)="retry()">
    <high-chart
        *ngIf="loader.dataLoader.data$ | async as data"
        height="380"
        [yAxis]="data.yAxis"
        [xAxis]="data.xAxis"
        [categories]="data.categories"
        [series]="data.series"
        [showHideBtn]="data.series.length > 1"
        [plotOptions]="data.plotOptions"
        [tooltipFormatter]="checkTooltipFormatter(isMultiTooltip)"
        [tooltipShared]="isMultiTooltip"
    ></high-chart>

    <div class="chart-error-message" *ngIf="isEmptyData && !loader.dataLoader.isLoading">
        {{ 'analytics.reports.barView.noDataToShow' | i18next }}
    </div>
</blur-chart-wrapper>
